<template>
  <v-dialog persistent v-model="showDialog" max-width="700px">
    <v-card flat class="pa-1 pt-0">
      <v-icon class="close" @click="showDialog = false; $emit('close')">$sl-close</v-icon>
      
        <h2 class="v-card__title no-transformed">Vill du verkligen koppla bort denna lärling?</h2> 
      
        Personen kommer att förlora alla roller och behörigheter som företaget givit.
        <br />
        <DatePicker 
          class="mt-14"
          label="Datum för bortkoppling" 
          :value="endDate"
          @input="endDate = $event"
          :clearable="true"
          placeholder="ÅÅÅÅ-MM-DD"
          persistentHint
          outlined
          required
        />
        <br />
        <strong>Bortkoppling av lärling går inte att ångra.</strong>
      <div>
        <v-btn
          depressed
          block
          class="mt-4 justify-left"
          :style="{ background: '#58d0d6' }"
          @click="showDialog = false; $emit('close')"
        ><v-icon class="mr-2">$sl-cancel</v-icon>Avbryt</v-btn>
        <v-btn
          block
          depressed
          class="mt-4 justify-left"
          :style="{ border: '1px solid #dededc', background: 'transparent' }"
          @click="disconnectApprenticeship"
        ><v-icon class="mr-2">$sl-unlink</v-icon>Koppla bort</v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import API from '@/services/api.js'
import DatePicker from '@/components/common/DatePicker.vue'
// @group Company
// DeleteEmployedModal component
export default {
  name: 'DisconnectModal',

  props: {
    // Should dialog be showed
    show: false,
    // fetch employee type
    type: {
      // `String`
      type: String,
      // The default value is: `employee`
      default: 'employee'
    },
    
    apprenticeshipId: {
      type: Number,
      default: 0
    },
  },

  data: () => ({
    showDialog: false,
    endDate: null
  }),

  components: {
    // ActionButton,
    DatePicker
  },

  watch: {
    /**
     * @vuese
     * Used to watch show prop and open modal
     */
    show(val) {
      this.showDialog = val
    },
  },

  methods: {
    /**
     * @vuese
     * Used to delete employe or apprentice based on type
     */
    disconnectApprenticeship() {   
      if(!this.endDate) return
      API.endApprenticeship(this.apprenticeshipId, {data: {endDate: this.endDate }})
        .then(response => {
          this.$events.fire('showInfo', 'Personen bortkopplad.')
          this.$emit('back-to-list')
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>

